import { FormlyFieldConfig } from '@ngx-formly/core';

export function dateRangeValidatorMessage(error: unknown, field: FormlyFieldConfig): string {
  return `Your date of age is invalid`;
}
